import React from "react";
import { useMessageSource } from "react-message-source";
import InsurancePlusInfo from "./info";
import Info from "../../../ui/widgets/info";

export default function Optional(): React.JSX.Element {
  const { getMessage } = useMessageSource();
  return (
    <>
      <Info title={getMessage("InsurancePlus.Info.title")}>
        {getMessage("InsurancePlusOptional.Info.text")}
      </Info>
      <InsurancePlusInfo />
    </>
  );
}
